import React, { useEffect, useState } from 'react';
import { MapContainer, Marker, Popup } from 'react-leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-boundary-canvas';
import './IndiaMapWithSTB.css';
import { callAPI } from '../../../../../axios';
import IndiaGeojsonData from './INDIA_boundary.json';

const INDIA_BOUNDS = [
  [6.5, 68.0],
  [37.1, 97.5]
];

const createSTBIcon = (stbCount, hotelType) => {
  const size = Math.max(20, Math.min(40, stbCount / 10));
  const color = hotelType === 'IHCL' ? '#e74c3c' : '#3498db';
  
  return new L.DivIcon({
    className: 'stb-marker',
    html: `
      <div style="
        width: ${size}px;
        height: ${size}px;
        background-color: ${color};
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 3px solid white;
        box-shadow: 0 2px 8px rgba(0,0,0,0.3);
        color: white;
        font-weight: bold;
        font-size: 12px;
      ">
        ${stbCount}
      </div>
    `,
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2]
  });
};

const IndiaMapWithSTB = (props) => {
  const {filterType} = props
  const [stbData, setStbData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  // const [filterType, setFilterType] = useState('all');
  const [loading, setLoading] = useState(true);
  const [map, setMap] = useState(null);

  useEffect(() => {
    fetchSTBData();
  }, []);

  useEffect(() => {
    if (filterType === 'all') {
      setFilteredData(stbData);
    } else {
      setFilteredData(stbData?.filter(item => item.hotelType === filterType));
    }
  }, [filterType, stbData]);

  // Add BoundaryCanvas tile layer when map is ready
  useEffect(() => {
    if (map) {
      // Create tile layer with boundary clipping
      const boundaryLayer = L.TileLayer.boundaryCanvas(
        'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        {
          boundary: IndiaGeojsonData,
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          maxZoom: 18,
          minZoom: 4
        }
      );
      
      boundaryLayer.addTo(map);

      // Optionally add India boundary outline
      L.geoJSON(IndiaGeojsonData, {
        style: {
          color: '#2c3e50',
          weight: 2,
          fillOpacity: 0,
          opacity: 1
        }
      }).addTo(map);
    }
  }, [map]);

  const fetchSTBData = async () => {
    try {
      const response = await callAPI('/indiaMap');
      setStbData(response);
      setFilteredData(response);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching STB data:', error);
      setLoading(false);
    }
  };

  const stats = {
    total: stbData?.length,
    ihcl: stbData?.filter(item => item.hotelType === 'IHCL')?.length,
    hms: stbData?.filter(item => item.hotelType === 'HMS')?.length
  };

  return (
    <div className="stb-map-container">
      {/* <div className="stats-header">
        <div className="stat-box">
          <div className="stat-number">{stats.total}</div>
          <div className="stat-label">Total STBs</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">{stats.hms}</div>
          <div className="stat-label">HMS</div>
        </div>
        <div className="stat-box">
          <div className="stat-number">{stats.ihcl}</div>
          <div className="stat-label">IHCL</div>
        </div>
        <div className="filter-box">
          <select 
            className="type-filter" 
            value={filterType} 
            onChange={(e) => setFilterType(e.target.value)}
          >
            <option value="all">All Hotels</option>
            <option value="IHCL">IHCL Only</option>
            <option value="HMS">HMS Only</option>
          </select>
        </div>
      </div> */}

      <MapContainer
        center={[20.5937, 78.9629]}
        zoom={5}
        maxBounds={INDIA_BOUNDS}
        maxBoundsViscosity={1.0}
        style={{ height: '100%', width: '100%' }}
        minZoom={4}
        maxZoom={18}
        ref={setMap}
      >
        {/* TileLayer is added via useEffect with BoundaryCanvas */}

        <MarkerClusterGroup
          chunkedLoading
          iconCreateFunction={(cluster) => {
            const count = cluster.getChildCount();
            let sizeClass = 'small';
            if (filterType ==="HMS") sizeClass = 'large';
            else if (filterType ==="IHCL") sizeClass = 'medium';

            return L.divIcon({
              html: `<div class="custom-cluster-icon ${sizeClass}"><span>${count}</span></div>`,
              className: 'custom-marker-cluster',
              iconSize: L.point(40, 40)
            });
          }}
        >
          {filteredData.map((stb, index) => (
            <Marker
              key={index}
              position={[stb.lat, stb.lng]}  // Changed from stb.latitude, stb.longitude
              icon={createSTBIcon(stb.STBcount, stb.hotelType)}  // Changed from stb.stbCount
            >
              <Popup className="stb-popup">
                <div className="popup-content">
                  <h3>{stb.hotelname}</h3>  {/* Changed from stb.hotelName */}
                  <div className="popup-details">
                    <div className="detail-row">
                      <span className="label">Location:</span>
                      <span className="value">{stb.city || 'N/A'}, {stb.pinCode || 'N/A'}</span>
                    </div>
                    <div className="detail-row">
                      <span className="label">Type:</span>
                      <span className={`value ${stb.hotelType.toLowerCase()}`}>
                        {stb.hotelType}
                      </span>
                    </div>
                    <div className="detail-row">
                      <span className="label">STB Count:</span>
                      <span className="stb-count">{stb.STBcount}</span>  {/* Changed from stb.stbCount */}
                    </div>
                  </div>
                </div>
              </Popup>
            </Marker>
          ))}
        </MarkerClusterGroup>
      </MapContainer>
    </div>
  );
};

export default IndiaMapWithSTB;
